import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import { reset } from 'numeral';

import { history, fetchWrapper } from '../helpers';

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: null,
        error: null,
        userLoading: true,
        dayCost: 0,
        halfDayCost: 0
    }
}

function createReducers() {
    return{
      deleteMessage,
      getCost
    }
    function deleteMessage(state){
      state.error= null;
    }
    function getCost(state,action){
      state.dayCost= action.payload.dayCost;
      state.halfDayCost= action.payload.halfDayCost;
      state.nonAdherentCost= action.payload.nonAdherentCost;
    }
}

function createExtraActions() {
    const baseUrl = `${import.meta.env.VITE_API_URL}/api`;

    return {
        login: login(),
        refreshToken: refreshToken(),
        logout: logout(),
        reset: reset(),
        updatepass: updatepass()
    };    

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async ({ email, password }) => fetchWrapper.post(`${baseUrl}/user`, { email, password })
        );
    }
    function refreshToken() {
      return createAsyncThunk(
          `${name}/refreshToken`,
          async () => fetchWrapper.post(`${baseUrl}/user/refresh`)
      );
    }
    function logout() {
      return createAsyncThunk(
          `${name}/logout`,
          async (user) => fetchWrapper.post(`${baseUrl}/user/logout/${user}`)
      );
    }
    function reset() {
      return createAsyncThunk(
          `${name}/reset`,
          async ({ email }) => fetchWrapper.post(`${baseUrl}/user/reset-password`,{ email })
      );
    }
    function updatepass() {
      return createAsyncThunk(
          `${name}/updatepass`,
          async ({ token, password }) => fetchWrapper.post(`${baseUrl}/user/update-password`,{ token, password })
      );
    }
}

function createExtraReducers() {
    return (builder) => {
        builder
            // login
            .addCase(extraActions.login.pending, (state) => {
                state.error = null;
                state.userLoading = true;
            })
            .addCase(extraActions.login.fulfilled, (state, action) => {
                const user = action.payload;
                state.user = user;
                const { from } = history.location.state || { from: { pathname: '/' } };
                history.navigate(from, { replace: true });
                state.userLoading = false;
            })
            .addCase(extraActions.login.rejected, (state, action) => {
                state.error = action.error;
                state.userLoading = false;
            })
            // refreshToken
            .addCase(extraActions.refreshToken.pending, (state) => {
                state.error = null;
                state.userLoading = true;
            })
            .addCase(extraActions.refreshToken.fulfilled, (state, action) => {
                const user = action.payload;
                state.user = user;
                state.userLoading = false;
            })
            .addCase(extraActions.refreshToken.rejected, (state, action) => {
                state.error = action.error;
                state.userLoading = false;
            })
            // logout
            .addCase(extraActions.logout.pending, (state) => {
                state.error = null;
            })
            .addCase(extraActions.logout.fulfilled, (state) => {
                state.user = null;
                history.navigate('/login', { replace: true });
            })
            .addCase(extraActions.logout.rejected, (state, action) => {
                state.error = action.error;
            })
            // reset
            .addCase(extraActions.reset.pending, (state) => {
                state.error = null;
            })
            .addCase(extraActions.reset.fulfilled, (state, action) => {
                state.error = action.payload;
            })
            .addCase(extraActions.reset.rejected, (state, action) => {
                state.error = action.error;
            })
            // updatepass
            .addCase(extraActions.updatepass.pending, (state) => {
                state.error = null;
            })
            .addCase(extraActions.updatepass.fulfilled, (state, action) => {
                history.navigate('/login', { replace: true });
                state.error = action.payload;
            })
            .addCase(extraActions.updatepass.rejected, (state, action) => {
                state.error = action.error;
                history.navigate('/login', { replace: true });
            });
    };
}
